// The SPA's language. Paraglide compiles messages/{id,en}.json into lib/paraglide (generated,
// never committed): features call `m.some_key()` at render, and the runtime picks the locale per
// project.inlang/paraglide.config.js — the viewer's choice, else their browser's, else Indonesian.
import { getLocale, setLocale, type Locale } from "./paraglide/runtime.js";

/** Each language in itself: a reader looks for their own, not for its name in the current one. */
export const LOCALE_NAMES: Record<Locale, string> = { id: "Bahasa Indonesia", en: "English" };

/** <html lang>, for screen readers and the browser's offer to translate. */
export function applyLocale(locale: Locale = getLocale()) {
  document.documentElement.lang = locale;
}

/**
 * Keeps the choice (the kd_locale cookie), then reloads: a string already on screen, or
 * computed when a module loaded, reads the new locale only on a fresh page.
 */
export function chooseLocale(locale: Locale, reload: () => void = () => location.reload()) {
  setLocale(locale, { reload: false });
  reload();
}
